import React, { useContext } from "react"
import { Link } from "gatsby"
import { StateContext } from "../el/provider"
import { motion } from "framer-motion"
import { ShoppingBagIcon } from "@heroicons/react/24/outline"
import { ShoppingCartIcon } from "@heroicons/react/24/outline"
import { twMerge } from "tailwind-merge"

const CartButton = () => {
  const { stateBag, stateCart } = useContext(StateContext)
  const [bagBin] = stateBag
  const [cart] = stateCart
  const cartBtnVariants = {
    start: {
      rotateY: 180,
      scale: 0,
      opacity: 0,
    },
    end: {
      rotateY: [180, 180, 0],
      scale: [0, 1, 1],
      opacity: [0, 1, 1],
      transition: { type: "tween", delay: 0.2, duration: 0.3 },
    },
  }

  const cartCountVariants = {
    start: {
      opacity: 0,
    },
    end: {
      opacity: 1,
      transition: { delay: 0.5, duration: 0.25 },
    },
  }
  return (
    <motion.div
      className="relative mr-2.5 shrink-0 rounded-full shadow-sm"
      variants={cartBtnVariants}
      initial="start"
      animate="end"
    >
      <Link
        to={cart ? `/form/order` : `/form/quote`}
        className="block h-full w-full rounded-full ring-2 ring-blue-300 p-1 text-slate-400 shadow-sm transition hover:ring-blue-500 hover:bg-blue-50 hover:text-slate-700 hover:shadow-none focus:outline-none"
        aria-label="Notifications"
      >
        {cart ? (
          <ShoppingCartIcon className="h-5 w-5 stroke-current" />
        ) : (
          <ShoppingBagIcon className="h-5 w-5 stroke-current" />
        )}
        {bagBin !== undefined && bagBin.length > 0 ? (
          <motion.span
            variants={cartCountVariants}
            className={twMerge([
              "absolute -right-1.5 -top-1 block rounded-full bg-teal-400 text-center align-middle text-xs leading-4 text-white ring-slate-200",
              bagBin !== undefined && bagBin.length > 10
                ? "px-1 py-0.5"
                : "h-4 w-4",
            ])}
          >
            {bagBin.length}
          </motion.span>
        ) : (
          ""
        )}
      </Link>
    </motion.div>
  )
}

export default CartButton
